import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "flowchart-ladder-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.74 4.26a1.75 1.75 0 10-2.48 2.48 1.75 1.75 0 002.48-2.48zM7.8 3.2a3.25 3.25 0 10.86 3.08h7a2.49 2.49 0 110 4.98H8.33a3.99 3.99 0 000 7.98h7a3.25 3.25 0 100-1.5h-7a2.49 2.49 0 110-4.98h7.33a3.99 3.99 0 100-7.98H8.67A3.24 3.24 0 007.8 3.2zm11.94 14.06a1.75 1.75 0 10-2.48 2.48 1.75 1.75 0 002.48-2.48z"
    }, null, -1)
  ])))
}
export default { render: render }